import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "button", "explanation"]
  static classes = ["locked"]

  unlock() {
    this.inputTarget.readOnly = false
    this.inputTarget.classList.remove(...this.lockedClasses)
    this.inputTarget.select()
    this.buttonTarget.remove()
    this.explanationTarget.remove()
  }
}
